<script>
	import { useLocation } from 'svelte-routing';
	import { onMount } from 'svelte';
	import { get } from 'svelte/store';
	export let legacy_component;
	export let params;

	// Read the navigate params, called payload
	const location = useLocation();

	let container_el;
	let payload = get(location).state;

	// Use -1 as starting, because null is a valid param
	let previous_params = -1;

	function build_component() {
		if (params === previous_params) {
			console.log('component params are the same');
			return;
		}

		container_el.innerHTML = '';

		console.log('diff params, reloading');

		if (legacy_component && typeof legacy_component.init === 'function') {
			container_el.append(legacy_component.init());
		}
		legacy_component?.show?.();
		legacy_component?.onshow?.(payload);

		previous_params = params;
	}

	onMount(build_component);

	// Rebuild the component when params are changed
	$: if (params) {
		// container_el guarantee it won't run on the first load
		if (container_el) {
			build_component();
		}
	}
</script>

<!-- Use two classes with components names due the double styling -->
<div class="app-screen {legacy_component?.id} {legacy_component?.id}-screen legacy-wrapper">
	<div id={legacy_component?.id} bind:this={container_el}></div>
</div>
